/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowUiAuthLogoutIcon32Regular = forwardRef('ArrowUiAuthLogoutIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M3 7.5A5.5 5.5 0 0 1 8.5 2H19a1 1 0 1 1 0 2H8.5A3.5 3.5 0 0 0 5 7.5v17A3.5 3.5 0 0 0 8.5 28H19a1 1 0 1 1 0 2H8.5A5.5 5.5 0 0 1 3 24.5v-17Z" }),
        React.createElement("path", { d: "m27.367 17-4.855 4.855a1 1 0 0 0 1.414 1.415l5.237-5.237a2.875 2.875 0 0 0 0-4.066L23.925 8.73a1 1 0 0 0-1.414 1.415L27.367 15H12a1 1 0 1 0 0 2h15.367Z" })));
});
